import type { PositionValue } from '@elfsight/configurator-contracts';

export const getCurrentPosition = (
  position: PositionValue,
  iconOnly: boolean,
  isMobile: boolean
) => {
  if (isMobile) {
    const isLeft = ['top-left', 'left', 'bottom-left'].includes(position);
    const isRight = ['top-right', 'right', 'bottom-right'].includes(position);

    if (iconOnly && isLeft) {
      return 'bottom-left';
    }

    if (iconOnly && isRight) {
      return 'bottom-right';
    }

    return 'bottom';
  }

  return position;
};
